import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim();
const CONSENT_KEY = 'luxe_cookie_consent';

const Analytics = () => {
  const location = useLocation();
  const [hasConsent, setHasConsent] = useState(() => localStorage.getItem(CONSENT_KEY) === 'accepted');

  useEffect(() => {
    const handleConsentChange = event => setHasConsent(event.detail === 'accepted');
    window.addEventListener('luxe:cookie-consent', handleConsentChange);
    return () => window.removeEventListener('luxe:cookie-consent', handleConsentChange);
  }, []);

  useEffect(() => {
    if (!hasConsent || !measurementId || !measurementId.startsWith('G-')) return;

    if (!document.querySelector(`script[data-ga-id="${measurementId}"]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.dataset.gaId = measurementId;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      // Google expects each gtag call to be stored as its arguments object.
      // Using the standard form also ensures the queued page-view is processed
      // correctly when the external Google script has finished loading.
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', measurementId, { send_page_view: false });
    }

    window.gtag?.('event', 'page_view', {
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}`,
      page_title: document.title,
    });
  }, [hasConsent, location.pathname, location.search]);

  return null;
};

export default Analytics;
